import { styled } from '../jss-style';
import linkStyle from './link';

const useLinkStyle = styled(linkStyle, 'link');
export { linkStyle, useLinkStyle };
export default useLinkStyle;
